<template>
  <div class="porder-detail">
    <el-dialog title="选择商品（配送单）" :close-on-click-modal="false" :visible.sync="dialogVisible" width="1480px" center>
      <div class="btn">
        <el-button type="primary" @click="selectCheckedItems">选中</el-button>
      </div>
      <div class="table">
        <ol>
          <li class="flex05">
            <el-checkbox v-model="checked" @change="handleCheckedChange">
              全选
            </el-checkbox>
          </li>
          <li class="flex05"> No</li>
          <li> 订单号 </li>
          <li class="flex05"> 番号 </li>
          <li class="flex2"> 商品信息</li>
          <li> 附加服务 </li>
          <li> 备注</li>
          <li> 标签信息</li>
          <li> 数量</li>
        </ol>
        <ul v-for="(item, index) in tableData" :key="index">
          <li class="flex05">
            <el-checkbox v-model="item.checked" @change="itemCheckedChange">

            </el-checkbox>
          </li>
          <li class="flex05"> {{ item.NO }}</li>
          <li>
            <router-link :to="'/orderPaymentDetail/order_sn=' + item.order_sn" class="a-link" target="_blank">
              {{ item.order_sn }}
            </router-link>
          </li>
          <li class="flex05"> {{ item.sorting }} </li>
          <li class="flex2">
            <div class="template">
              <div class="product">
                <a :href="item.link" target="_blank" rel="noopener noreferrer">
                  <img :src="item.pic" alt=""></img>
                </a>
                <div class="product-info">
                  <p v-for="(detail, detailIndex) in item.detail_y" :key="detailIndex">
                    {{ detail.key }} : {{ detail.value }}
                  </p>
                </div>
              </div>
            </div>
          </li>
          <li>
            <div class="template">
              <div class="service" style="max-height: 150px; overflow-y: auto;">
                <p v-for="(option, optionIndex) in item.option" :key="optionIndex">
                  {{ optionIndex + 1 }} : {{ option.name }}
                </p>
              </div>
            </div>
          </li>
          <li> {{ item.client_remark }}</li>
          <li>
            <div class="template">
              <div class="tag" v-for="(tag, tagIndex) in item.porder_detail_tag" :key="tagIndex">
                <p>
                  {{ tag.type }}
                </p>
                <p>
                  {{ tag.no }}
                </p>
                <p>
                  {{ tag.text_line_one }}
                </p>
              </div>
            </div>
          </li>
          <li>
            <div class="template">
              <p>
                购买数：{{ item.num }}

              </p>
              <p>
                本次出货数：{{ item.possible_num }}
              </p>

            </div>
          </li>
        </ul>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dialogVisible: false,
      checked: false,
      porder_sn: '',
      tableData: []
    }
  },
  methods: {
    getPorderDetail() {
      this.$api.porderApi.porderDetail({ porder_sn: this.porder_sn }).then(res => {
        res.data.list.forEach(item => {
          item.checked = false
          item.possible_num = 0
          //计算上架可能数
          item.order_purchase.forEach(items => {
            item.possible_num += items.possible_num
          })
        })
        this.tableData = res.data.list
        this.dialogVisible = true
        console.log(res.data);
      })
    },
    // 全选/取消全选
    handleCheckedChange() {
      this.tableData.forEach(item => {
        item.checked = this.checked
      })
    },
    // 商品选择改变时，更新全选状态
    itemCheckedChange() {
      // 计算全选状态
      this.checked = this.tableData.every(item => item.checked)
    },
    // 选中选中项
    selectCheckedItems() {
      let checkedItems = this.tableData.filter(item => item.checked)
      if (checkedItems.length == 0) {
        this.$message.error('请选择商品');
        return;
      }
      let porder_detail = []
      checkedItems.forEach(item => {
        porder_detail.push({
          id: item.order_detail_id,
          sorting: item.sorting,
          order_sn: item.order_sn
        })
      })
      console.log(1, this.$parent.form);

      this.$parent.form.porder_detail = porder_detail
      this.dialogVisible = false
      this.$forceUpdate()
    }
  }
}
</script>
<style lang='scss' scoped>
.btn {
  margin-bottom: 20px;
  text-align: right;
}

.table {
  max-height: 600px;
  overflow-y: auto;

  .flex05 {
    flex: 0.5;
  }

  .flex2 {
    flex: 2;
  }

  .product {
    display: flex;

    img {
      width: 100px;
      height: 100px;
      margin-right: 10px;
    }
  }
}
</style>